const supportTypes = {
  GET_ALL_TICKETS: 'GET_ALL_TICKETS',
  GET_TICKETS_BY_STATUS: 'GET_TICKETS_BY_STATUS',
  GET_SINGLE_TICKETS: 'GET_SINGLE_TICKETS',
  UPDATE_TICKET_STATUS: 'UPDATE_TICKET_STATUS',
  CREATE_MESSAGE: 'CREATE_MESSAGE'
};

export default supportTypes;
